import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

/** `?reduced-motion` forces the reduced path on, for QA without changing OS settings. */
const forced = () =>
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('reduced-motion')

export function useReducedMotion() {
  const [reduced, setReduced] = useState(
    () => forced() || (typeof window !== 'undefined' && window.matchMedia(QUERY).matches),
  )

  useEffect(() => {
    const media = window.matchMedia(QUERY)
    const onChange = () => setReduced(forced() || media.matches)
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return reduced
}
